import HorizontalImageCard from "../elements/horizontalImageCard";


export default function CarouselCard2() {

    return (
        <div className="flex">

            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 md:w-full mx-12">
                    <div className="swiper-slide card-slide card-slide-left  ">

                        <HorizontalImageCard
                            imageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/2156922.webp"
                            imageAlt="New York Programs #1"
                            title="Based in Major US Cities"
                            blurb="Our Startup Trainers are based in major US cities and can be accessed virtually and in-person if need be. Most trainers are located in NYC and Silicon Valley."
                        />
                    </div>
                    <div className="swiper-slide card-slide card-slide-center  ">

                        <HorizontalImageCard
                            imageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/31081287.webp"
                            imageAlt="Why We Use Startup Trainers?"
                            title="Why We Use Startup Trainers?"
                            blurb="
                            Every Startup Trainer is held to a high standard: they've launched a consumer product that scaled to over 100,000 users and raised more than $1 million in funding. These are hard requirements. You genuinely learn from someone who has actually done it.
                            "
                        />
                    </div>


                </div>

            </div>
        </div>
    )
}